module.exports = __webpack_public_path__ + "static/b&d logo-0bd6cc3aa222e5374cc50d93c0eba347.jpg";